import React from 'react'
import { Row } from 'react-bootstrap'
import Button from './button'
import MAILBOX_TYPES from '../../../constants/mailbox-types'

const MessagingHeader = ({
    onMailboxTypeChange = () => {},
    mailboxType = MAILBOX_TYPES.IN
}) => {
    return (
        <Row>
            <Button onClick={() => onMailboxTypeChange(MAILBOX_TYPES.IN)} active={mailboxType===MAILBOX_TYPES.IN}>INBOX</Button>
            <Button onClick={() => onMailboxTypeChange(MAILBOX_TYPES.OUT)} active={mailboxType===MAILBOX_TYPES.OUT}>SENT</Button>
        </Row>
    )
}
export default MessagingHeader